/* eslint-disable no-param-reassign */
const sizesConfig = [
  {
    maxWidth: 1500,
    sizes: `calc(93.333vw - 508px)`,
  },
  {
    maxWidth: 1800,
    sizes: `calc(100vw - 608px)`,
  },
  {
    maxWidth: 2000,
    sizes: `66vw`,
  },
  {
    maxWidth: 2200,
    sizes: `60vw`,
  },
  {
    maxWidth: 2400,
    sizes: `54vw`,
  },
  {
    sizes: `50vw`,
  },
];

// zoom scales every entry, for a photo drawn larger than its box by a transform
const usePDPDesktopHeroSizeProps = (zoom = 1) => ({
  sizes: sizesConfig.reduce((acc, { maxWidth, sizes }, idx) => {
    const zoomedSizes = zoom === 1 ? sizes : `calc(${sizes} * ${zoom})`;
    acc += `${maxWidth ? `(max-width: ${maxWidth}px)` : ''} ${zoomedSizes}`;
    if (idx < sizesConfig.length - 1) {
      acc += ', ';
    }
    return acc;
  }, ''),
});

export default usePDPDesktopHeroSizeProps;
